export default `
<div>
  <div class="grid w890">
    <h2 class="underline" >My Discussions</h2>
    <feed-item item='discussion' ng-repeat='discussion in discussions.feedItems' class="compressed" ></feed-item>
    <ut-load-more (load-more)="discussions.loadMore()" [is-loading]="discussions.isLoading" [is-last-page]="discussions.isLastPage"></ut-load-more>
  </div>
</div>
`;
